import { useVehicleAvailability } from '~/context/vdp/UserVehicleContext';
import { useGetIsWIPVehicle } from '~/context/vdp/VehicleContext';

export default function useIsWipVehicleReservedByUser() {
  const { isLockedByThisUser = false } = useVehicleAvailability();
  const isWIPVehicle = useGetIsWIPVehicle();

  return isLockedByThisUser && isWIPVehicle;
}
